// Copyright (c) 2016 Deere & Company

import {
    updateUserLanguageSettings,
    updateUserSettings
} from './user';
import actions from '../../actions-list';
import {addRemoveModalClass} from '../../../shared/services/add-remove-modal-class';
import {getRacfId} from '../../shared/repositories';
import {getStore} from '../../../store-factory';
import {readLinks} from '../../../app/action-creators/links';
import {routerActions} from 'react-router-redux';

export const updateConfirmSaveModalVisibility = isVisible =>

    dispatch => {

        addRemoveModalClass(isVisible);

        dispatch({
            isVisible,
            type: actions.UPDATE_USER_PREFERENCES_CONFIRM_SAVE_MODAL_VISIBILITY
        });

    };

export const confirmSaveModal = nextLocation =>

    async (dispatch, getState) => {

        try {

            await updateUserSettings()(dispatch, getState);

            updateConfirmSaveModalVisibility(false)(dispatch);

            dispatch(routerActions.push(nextLocation));

        } catch (error) {

        }

    };

export const closeConfirmSaveModal = nextLocation =>

    async dispatch => {

        try {

            await getRacfId(getStore());

            updateConfirmSaveModalVisibility(false)(dispatch);

            dispatch({
                data: true,
                type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
            });

            dispatch(routerActions.push(nextLocation));

        } catch (error) {

        }

    };

export const confirmSaveModalForLanguageSettings = nextLocation =>

    async (dispatch, getState) => {

        try {

            await updateUserLanguageSettings()(dispatch, getState);

            updateConfirmSaveModalVisibility(false)(dispatch);

            dispatch({
                data: true,
                type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
            });

            readLinks()(dispatch);

            dispatch(routerActions.push(nextLocation));

        } catch (error) {

        }

    };



// WEBPACK FOOTER //
// ./src/user/shared/action-creators/confirm-save-modal.js